export type DeepLinkTarget = { kind: "sso-callback"; loginPath: string | null } | { kind: "navigate"; href: string } | { kind: "ignore" };

// Region-specific hosts that a co.valence.nadia:// deep link may target. Kept
// in sync with settings.DEPLOYMENT_HOSTNAMES; add any new per-deployment host
// here so cross-region links resolve to an absolute URL on the right cluster.
export const VALENCE_APP_HOSTS: ReadonlySet<string> = new Set([
    "coach.valence.co",
    "coach-eu.valence.co",
    "nadia.vanguard.valence.co",
    "nadia.private.valence.co",
    "staging.coach.valencetest.co",
    "staging-eu.coach.valencetest.co",
]);

// Resolve a deep-link URL into an action for the appUrlOpen handler to apply.
// Only the URL pathname is preserved on cross-region navigation — query and
// fragment are dropped as defense-in-depth against ?next= injection (LAB-904).
export function resolveDeepLinkTarget(rawUrl: string): DeepLinkTarget {
    let parsed: URL;
    try {
        parsed = new URL(rawUrl);
    } catch {
        return { kind: "ignore" };
    }

    if (parsed.host === "sso-callback") {
        const st = parsed.searchParams.get("st");
        return {
            kind: "sso-callback",
            loginPath: st ? `/accounts/st/login?st=${encodeURIComponent(st)}&mobile=1&sso=1` : null,
        };
    }

    if (VALENCE_APP_HOSTS.has(parsed.hostname)) {
        return { kind: "navigate", href: `https://${parsed.hostname}${parsed.pathname}` };
    }

    return { kind: "ignore" };
}
